export const EMAIL_REGEX = /^\w+(?:[\.-]?\w+)*@\w+(?:[\.-]?\w+)*(\.\w{2,5})+$/;
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[!_?;:.,€¢£¥₹`"'{}~|/><()+=@#$%^&*-])(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
export const URL_REGEX = /^(http(s)?:\/\/)?(www.)?([a-zA-Z0-9])+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/[^\s]*)?$/gm;

export const dictionary: Record<string, Record<string, string>> = {
	en: {
		show_page_count: "Show {pageCount}",
		invalidDate: "Invalid Date",
		noDataAvailable: "-",
		fieldRequired: "Oops. Looks like you missed this.",
		invalidEmail: "Please enter a valid email. Don’t worry, we hate spam too.",
		invalidLink: "Please enter a valid URL.",
		invalid_field: "Invalid field",
		invalidPhone: "Invalid phone number",
		addNew: "Add New",
		yes: "Yes",
		no: "No",
		view_more: "View More",
		previous: "Previous",
		next: "Next",
		show_current_page: "Page {currentPage} of {totalPages}",
		cancel: "Cancel",
		apply: "Apply",
		today: "Today",
		noDataFound: "No data found",
		ascending: "Ascending",
		descending: "Descending"
	},
	es: {
		show_page_count: "Show {pageCount}",
		invalidDate: "Invalid Date",
		noDataAvailable: "-",
		fieldRequired: "Oops. Looks like you missed this.",
		invalidEmail: "Please enter a valid email. Don’t worry, we hate spam too.",
		invalidLink: "Please enter a valid URL.",
		invalid_field: "Invalid field",
		invalidPhone: "Invalid phone number",
		addNew: "Add New",
		yes: "Yes",
		no: "No",
		view_more: "View More",
		previous: "Previous",
		next: "Next",
		show_current_page: "Page {currentPage} of {totalPages}",
		cancel: "Cancel",
		apply: "Apply",
		today: "Today",
		noDataFound: "No data found",
		ascending: "Ascending",
		descending: "Descending"
	}
};

export const DEFAULT_MAX_AMOUNT: number = 999999999;
export const DEFAULT_MIN_AMOUNT: number = 0;
export const DEFAULT_MAX_LENGTH: number = 100;
export const DEFAULT_CURRENCY: string = "USD";
export const DEFAULT_CURRENCY_SYMBOL: string = "$";
export const DATE_FORMATE: string = "MM/DD/YYYY";
export const DATE_TIME_FORMATE: string = "MM/DD/YYYY @ h:mm A";
export const INPUT_DATE_TIME_FORMATE: string = "YYYYMMDD-HHmmss";
export const STANDARD_DATE_FORMAT: string = "YYYY-MM-DD";
